import React, { useEffect } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { Formik, Form, Field } from 'formik';
import { useDispatch } from 'react-redux';
import { AppDispatch } from '../Appstore/store';
import { UpdateIpAddress, GetAllipAddress } from '../Features/AllowIpData';
import * as Yup from 'yup';
import { setIsLoading } from '../Features/loadingSlice';
import { toast } from 'sonner';

interface UpdateAllowIPProps {
    show: boolean;
    onHide: () => void;
    selectedId: number | null;
    currentIpData: { ip: string; status: number } | null;
}

const validationSchema = Yup.object({
    ip: Yup.string()
        .matches(
            /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/i,
            'Invalid IP address'
        )
        .required('IP Address is required'),
    status: Yup.string().required('Status is required'),
});

const UpdateAllowIP: React.FC<UpdateAllowIPProps> = ({ show, onHide, selectedId, currentIpData }) => {
    const dispatch = useDispatch<AppDispatch>();

    useEffect(() => {
        if (show) {
            dispatch(setIsLoading(true));
            setTimeout(() => {
                dispatch(setIsLoading(false));
            }, 500);
        }
    }, [show, dispatch]);

    const initialValues = {
        ip: currentIpData ? currentIpData.ip : '',
        status: currentIpData ? currentIpData.status : 0,
    };

    return (
        <>
            <Modal show={show} onHide={onHide} centered>
                <Modal.Header closeButton className="border-0">
                    <Modal.Title>Edit IP Address</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Formik
                        initialValues={initialValues}
                        validationSchema={validationSchema}
                        onSubmit={async (values, { resetForm }) => {
                            if (selectedId === null) {
                                console.error('No ID provided for update.');
                                return;
                            }

                            const allowipData = {
                                ip: values.ip,
                                status: Number(values.status),
                            };
                            try {
                                const response: any = await dispatch(UpdateIpAddress({ id: selectedId, allowipData }));

                                const defaultPage = 1;
                                const defaultLimit = 10;

                                if (response.payload && response.payload.status === 'success') {
                                    toast.success(response.payload.message);
                                    resetForm();
                                    onHide();
                                    await dispatch(GetAllipAddress({ search: '', page: 1, limit: 10 }));
                                } else if (response.payload?.status === 'error') {
                                    const backendErrorMessage = response.payload.message || 'Invalid credentials';
                                    toast.error(backendErrorMessage);
                                }
                            } catch (error:any) {
                                const errorMessage = error.message || 'An unexpected error occurred';
                                toast.error(errorMessage);
                            }
                        }}
                    >
                        {({ errors, touched, handleChange, values, isSubmitting }) => (
                            <Form>
                                <div className="form-group mb-3">
                                    <label htmlFor="ip">IP Address<span className="text-danger">*</span></label>
                                    <Field
                                        type="text"
                                        className={`form-control shadow-none ${touched.ip && errors.ip ? 'is-invalid' : ''}`}
                                        id="ip"
                                        name="ip"
                                        placeholder="Enter IP Address"
                                    />
                                    {touched.ip && errors.ip ? (
                                        <div className="invalid-feedback">{errors.ip}</div>
                                    ) : null}
                                </div>

                                <div className="form-group mb-3">
                                    <label>Status<span className="text-danger">*</span></label>
                                    <select
                                        name="status"
                                        className="form-select shadow-none"
                                        value={values.status}
                                        onChange={handleChange}
                                    >
                                        <option value={1}>Active</option>
                                        <option value={0}>Deactive</option>
                                    </select>
                                    {touched.status && errors.status && (
                                        <div className="text-danger">{errors.status}</div>
                                    )}
                                </div>

                                <Modal.Footer className="d-flex justify-content-center border-0">
                                    <Button style={{ width: 100 }} variant="primary" type="submit" disabled={isSubmitting}>
                                        {isSubmitting ? (
                                            <>
                                                <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                                <span className='ps-2'>Save...</span>
                                            </>
                                        ) : (
                                            "Save"
                                        )}
                                    </Button>
                                    <Button style={{ width: 100 }} variant="secondary" onClick={onHide}>
                                        Close
                                    </Button>
                                </Modal.Footer>
                            </Form>
                        )}
                    </Formik>
                </Modal.Body>
            </Modal>
        </>
    );
};

export default UpdateAllowIP;
